import { useQuery } from "react-query";

import { dropdownValuesService } from "services";

type useAdjustmentCategoriesProps = {
	options?: any;
};

const useAdjustmentCategoriesQuery = ({
	options,
}: useAdjustmentCategoriesProps = {}) =>
	useQuery(
		"adjustmentCategories",
		dropdownValuesService.getAdjustmentCategories,
		{
			...options,
		},
	);

export default useAdjustmentCategoriesQuery;
